import { toast } from 'sonner'

import { type PayrollProviderConfig } from 'utils/web_api.schemas'
import { useWindowLocation } from 'utils/windowLocation'

import PayrollConnectionPicker from './payroll/PayrollConnectionPicker'

export const EmployerOnboardingPayrollConnectionPicker = ({
  payrollProviders,
  promotedPayrollProviders,
  onSuccessPayScheduleUrl = '/employer_onboarding/manual_deductions',
  onSuccessBankingUrl = '/employer_onboarding/banking',
  onSuccessAutomatedUrl = '/employer_onboarding/automatic_deductions',
  onFailureUrl = 'employer_onboarding/payroll',
}: {
  payrollProviders: PayrollProviderConfig[];
  promotedPayrollProviders: PayrollProviderConfig[];
  onSuccessPayScheduleUrl?: string;
  onSuccessBankingUrl?: string;
  onSuccessAutomatedUrl?: string;
  onFailureUrl?: string;
}) => {
  const { assign } = useWindowLocation()

  return (
    <PayrollConnectionPicker
      payrollProviders={payrollProviders}
      promotedPayrollProviders={promotedPayrollProviders}
      onSuccessCallback={({ supportsAutomatedDeductions, supportsPaySchedules }) => {
        if (supportsAutomatedDeductions) {
          assign(onSuccessAutomatedUrl)
        } else if (!supportsPaySchedules) {
          assign(onSuccessPayScheduleUrl)
        } else {
          assign(onSuccessBankingUrl)
        }
      }}
      onSuccessUrl={onSuccessBankingUrl}
      onFailureCallback={() => {
        toast.error('Failed to connect to payroll provider. Please try again.')
      }}
      onFailureUrl={onFailureUrl}
    />
  )
}
